import React, { useEffect } from 'react';
import { useWindRoseContext } from './context';
import { useStyles } from './styles';

interface WindRoseProps {
  randomSpinnerId: string;
  onTop?: boolean;
  isAppSpinner?: boolean;
  isGallery?: boolean;
  onLoad?: () => void;
}

export const WindRose: React.FC<WindRoseProps> = ({
  randomSpinnerId,
  onTop = false,
  isAppSpinner = false,
  isGallery = false,
  onLoad,
}) => {
  const styles = useStyles({});
  const { windRoseData } = useWindRoseContext();

  useEffect(() => {
    if (onLoad && windRoseData) {
      onLoad();
    }
  }, [windRoseData, onLoad]);

  if (!windRoseData || !windRoseData.src) {
    return null;
  }

  return (
    <div
      id={`wind_rose${randomSpinnerId}`}
      className={`wind_rose hide ${
        styles.windRose
      } ${
        onTop && styles.onTop
      } ${
        isGallery && styles.isGallery
      }`}
      style={{
        height: '100%',
        display: (!windRoseData?.src || windRoseData?.disabled) ? 'none' : 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${windRoseData?.bg_src})`,
      }}
    >
      <div
        className={`${windRoseData?.bg_src ? styles.arrowWrapperWithBg : styles.arrowWrapper} img-wrapper`}
        style={{
          transform: `rotateZ(${windRoseData.degree}deg)`,
        }}
      >
        <img
          alt="icon"
          className={windRoseData?.bg_src ? styles.arrowWithBg : styles.arrow}
          src={windRoseData.src}
        />
      </div>
    </div>
  );
};
